import { render, staticRenderFns } from "./inputDocumentType.vue?vue&type=template&id=42bc9218&scoped=true&"
import script from "./inputDocumentType.vue?vue&type=script&lang=js&"
export * from "./inputDocumentType.vue?vue&type=script&lang=js&"
import style0 from "./inputDocumentType.vue?vue&type=style&index=0&id=42bc9218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc9218",
  null
  
)

export default component.exports